<template>
    <div>
        <label :style="'color:' + fieldsColor" :class="{'required': field.required}"
               v-if="path.hideTitle === undefined || !path.hideTitle">
            {{ field.name }}
            <help-tooltip :content="field.helpDescription"></help-tooltip>
        </label>

        <v-radio-group row class="mt-auto mb-auto w-auto" :value="fieldValue"
                       :class="{'input-error': submitted && field.required && fieldValue === null}"
                       hide-details
                       @change="updateFieldValue($event)" style="padding-top: 0 !important;">
            <v-radio :color="primaryColor" label="Oui" class="text" :value="true"></v-radio>
            <v-radio :color="primaryColor" label="Non" class="text" :value="false"></v-radio>
            <v-radio :color="primaryColor" label="Non communiqué" class="text" value="null"></v-radio>
        </v-radio-group>
    </div>
</template>

<script>
import HelpTooltip from "../../../tools/HelpTooltip.vue"

import {mapGetters, mapMutations, mapState} from "vuex"
import {fieldsMapping} from "../../../../static/webform"

export default {
    name: "FormRadio",
    props: ['field'],
    components: {HelpTooltip},
    methods: {
        ...mapMutations('web_form', ['updateProviderFieldValue']),
        updateFieldValue(value) {
            this.updateProviderFieldValue([this.path, value])
        }
    },
    computed: {
        ...mapState("webFormStyle", ["fieldsColor", "primaryColor"]),
        ...mapState("web_form", ['submitted', 'provider']),
        ...mapGetters('web_form', ['getCodeFromField', 'getProviderFieldValue']),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        path() {
            return fieldsMapping.find(path => path.code === this.fieldCode)
        },
        fieldValue() {
            return this.getProviderFieldValue(this.path)
        },
        placeholder() {
            return this.path.placeholder !== undefined ? this.path.placeholder : null
        }
    }
}
</script>